import { inject, Injectable } from '@angular/core';
import * as joint from '@clientio/rappid';
import { TranslocoService } from '@jsverse/transloco';

import { SelectionBehavior } from '@treetop/shared/model';

import { FlowchartLoaderService } from './flowchart-loader.service';
import { FlowchartElementsSubjectStore } from '../data/flowchart-elements-subject-store.service';
import { BaseGraph } from '../flowchart/graph/BaseGraph';
import { FlowchartModelService } from '../flowchart/model.service';
import { BasePaper } from '../flowchart/paper/BasePaper';
import { FlowchartViewService } from '../flowchart/view.service';
import { SelectionBehaviorElement } from '../shapes/selection-behavior';

@Injectable()
export default class SelectionBehaviorService {
  private flowchartViewService = inject(FlowchartViewService);
  private FlowchartModelService = inject(FlowchartModelService);
  private translocoService = inject(TranslocoService);

  private flowchartElementsSubjectStore = inject(FlowchartElementsSubjectStore);

  public paperSource: BasePaper;
  public graphSource: BaseGraph;

  constructor() {
    this.paperSource = this.flowchartViewService.getPaper();
    this.graphSource = this.FlowchartModelService.getGraph();
  }

  toggleMenu(target: SelectionBehaviorElement, flowchartLoaderService: FlowchartLoaderService, targetId?: string): void {
    const cell = this.graphSource.graph.getCell(target.id);
    const view = this.paperSource.paper.findViewByModel(cell);
    const htmlElement = view?.el as SVGAElement;

    let tools: [{ [key: string]: string }];

    Object.values(SelectionBehavior)
      .filter((key) => isNaN(Number(SelectionBehavior[key])))
      .forEach((sel) => {
        tools === undefined
          ? (tools = [{ content: this.translocoService.translate(SelectionBehavior[sel]), action: SelectionBehavior[sel] }])
          : tools.push({ content: this.translocoService.translate(SelectionBehavior[sel]), action: SelectionBehavior[sel] });
      });

    const toolbar = new joint.ui.ContextToolbar({
      tools: tools,
      target: htmlElement,
      vertical: true,
      padding: 0,
    });

    toolbar.el.classList.add('selection-behavior-toolbar');

    const setLabelText = (selectionBehaviorTitle: string, selectionBehaviorValue: SelectionBehavior) => {
      if (target.attributes.type === 'treetop.SelectionBehavior') {
        target.setText(selectionBehaviorTitle);
      } else {
        target.prop('attrs/label/text', selectionBehaviorTitle.toString());
      }
      const targetElementId = targetId || (target.id as string);
      flowchartLoaderService.setSelectionBehaviorValue(this.flowchartElementsSubjectStore, targetElementId, selectionBehaviorValue);
      toolbar.remove();
    };

    //switch caret icon
    target.prop('attrs/image/xlink:href', '/assets/icons/chevron-up.svg');

    Object.values(SelectionBehavior)
      .filter((key) => isNaN(Number(SelectionBehavior[key])))
      .forEach((sel: SelectionBehavior) => {
        toolbar.on('action:' + SelectionBehavior[sel], () => {
          target.prop('attrs/image/xlink:href', '/assets/icons/chevron-down.svg');
          setLabelText(this.translocoService.translate(SelectionBehavior[sel]).toString(), sel);
        });
      });

    toolbar.render();
  }
}
